<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <!-- <img src="./assets/img/toplogo.png" alt /> -->
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">HOME</el-menu-item>
          <el-menu-item index="/about">ABOUT US</el-menu-item>
          <el-menu-item index="/contact">CONTACT US</el-menu-item>
          <el-menu-item index="/privacy-policy">PRIVACY POLICY</el-menu-item>
          <el-menu-item index="/refund">REFUND AND CANCELLATION</el-menu-item>
          <el-menu-item index="/terms">T&C</el-menu-item>
          <el-menu-item index="/legal">LEGAL OPINION</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <!-- <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>走进科建</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：kejianlml@163.com</span>
              <span>电话：021-55802368</span>
              <span>地址：上海市杨浦区翔殷路128号12号楼101</span>
            </li>
          </ul>
          <img src="./assets/img/ercode.png" alt />
        </div>
        <div class="copyright">
          <span>科建版权所有</span>
        </div>
      </div> -->
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  mounted() {
    // const computed = function () {
    //   // 设计稿宽度：1920
    //   const desW = 1920
    //   const devW = document.documentElement.clientWidth
    //   if (devW > 1280) {
    //     document.documentElement.style.fontSize = devW / desW * 75 + 'px'
    //     // 这里的75是使用postcss-px2rem插件时，配置的remUnit的参数值
    //   } else {
    //     document.documentElement.style.fontSize = 50 + 'px'
    //   }
    // }
    // computed()
    // window.addEventListener('resize', computed, false)
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  width: 100%;
  background: #700b10;
	display: flex;
	justify-content: space-between;
  height: auto !important;

  .logo {
    margin-left: 18.7%;
    img {
      width: 100%;
    }
  }

  .el-menu-demo {
    display: flex;
    align-items: center;
    margin-right: 18.7%;
    margin-top: 30px;
    width: 100%;
    margin-bottom: 20px;
    background: transparent !important;
    border: none !important;
    height: 100px;
    flex-wrap: wrap;

     .el-menu-item {
      width: auto;
      padding: 0 20px;
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      text-align: left;
      font-weight: 600;
      color: white;

      &:hover {
        background: #14679f;
      }

      
    }
    .el-menu-item:hover {
        background: gainsboro !important;
        color: black !important;
    }

    .el-menu-item.is-active {
      color: black;
      border: none;
      background: white;
    }
  }
}
.el-main {
  padding: 0 !important;
  overflow: auto !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
